<div class="changelog">
  <p class="tab-state" *ngIf="loading">{{ 'common.loading' | translate }}</p>
  <p class="tab-state error" *ngIf="!loading && error">{{ 'audiences.additionalInfo.changelog.error' | translate }}</p>
  <p class="tab-state" *ngIf="!loading && !error && !events.length">{{ 'audiences.additionalInfo.changelog.empty' | translate }}</p>

  <ol class="changelog__list" *ngIf="!loading && !error && events.length">
    <li class="changelog__item" *ngFor="let ev of events; trackBy: trackByIndex">
      <span class="changelog__dot"></span>
      <div class="changelog__body">
        <div class="changelog__meta">
          <span class="changelog__date">{{ formatDate(ev.UpdateDatetime) }}</span>
          <span class="changelog__user" *ngIf="ev.UserName">· {{ ev.UserName }}</span>
        </div>
        <div class="changelog__desc">{{ ev.Description }}</div>
      </div>
    </li>
  </ol>
</div>
